import { Radio } from '@mantine/core';

export const RadioResolver = Radio.extend({
  styles: {
    radio: {
      boxSizing: 'border-box',
    },
  },
});
